export default __webpack_public_path__ + "static/reed-3--mobile-0edff73e441319ef87a6066543381b27.webp";